import React from 'react';
import './Card.css';
const Card = ({ doctorName, cardText, image }) => {
  return (
    <div className="Card">
      <div className="Card-img">
        <img src={image} alt="Card" />
      </div>
      <div className="Card-name">
        <h4 className="doctor-name">{doctorName}</h4>
      </div>
      <hr className="hr-1" />
      <div className="Card-text">
        {cardText}
      </div>
      <div className="Card-socials">
        {/* <i className="fa-brands fa-facebook-f"></i>
        <i className="fa-brands fa-twitter"></i>
        <i className="fa-regular fa-envelope"></i>
        <i className="fa-brands fa-linkedin-in"></i> */}
      </div>
    </div>
  );
};

export default Card;